import React from 'react';
import { Wrapper } from './MListTextIcon.styles';
import { type MListTextIconProps, MListTextIconSize } from './MListTextIcon.types';
import { AIcon } from '../../atoms/AIcon';
import { type AIconProps, AIconSize } from '../../atoms/AIcon/AIcon.types';
import { ATextInteractive } from '../../atoms/ATextInteractive';
import { type ATextInteractiveProps, ATextInteractiveSize } from '../../atoms/ATextInteractive/ATextInteractive.types';

const COMPONENT_NAME = 'm-web-ui-kit-MListTextIcon';
const TEST_ID = 'web-ui-kit-MListTextIcon';

const SIZE_MAP = {
  [MListTextIconSize.XS]: { aIconSize: AIconSize.S, aTextInteractiveSize: ATextInteractiveSize.XS },
  [MListTextIconSize.S]: { aIconSize: AIconSize.S, aTextInteractiveSize: ATextInteractiveSize.S },
  [MListTextIconSize.M]: { aIconSize: AIconSize.M, aTextInteractiveSize: ATextInteractiveSize.M },
};
function MListTextIcon({ size = MListTextIconSize.M, aIcon = {}, aTextInteractive, ...rest }: MListTextIconProps) {
  const sizeMap = SIZE_MAP[size];
  const _aIcon = {
    ...aIcon,
    size: sizeMap?.aIconSize,
  };
  const _aTextInteractive = aTextInteractive
    ? {
        ...aTextInteractive,
        size: sizeMap?.aTextInteractiveSize,
      }
    : null;

  return (
    <Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      {_aIcon.icon && <AIcon {...(_aIcon as AIconProps)} />}
      {_aTextInteractive?.text && <ATextInteractive {...(_aTextInteractive as ATextInteractiveProps)} />}
    </Wrapper>
  );
}

export { MListTextIcon, MListTextIconSize, TEST_ID as M_LIST_TEXT_ICON_TEST_ID };
